var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWomensHealth(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    rx: 12,
    fill: "#ECEBFD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 26C27.4183 26 31 22.4183 31 18C31 13.5817 27.4183 10 23 10C18.5817 10 15 13.5817 15 18C15 22.4183 18.5817 26 23 26ZM34 18C34 23.5663 29.8655 28.167 24.5 28.8986V32H27C27.8284 32 28.5 32.6716 28.5 33.5C28.5 34.3284 27.8284 35 27 35H24.5V37C24.5 37.8284 23.8284 38.5 23 38.5C22.1716 38.5 21.5 37.8284 21.5 37V35H19C18.1716 35 17.5 34.3284 17.5 33.5C17.5 32.6716 18.1716 32 19 32H21.5V28.8986C16.1345 28.167 12 23.5663 12 18C12 11.9249 16.9249 7 23 7C29.0751 7 34 11.9249 34 18Z",
    fill: "#5049A6"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWomensHealth);
export default __webpack_public_path__ + "static/media/womens-health.5d47d6f1d09d80f6bdedc824f2190a59.svg";
export { ForwardRef as ReactComponent };